import { postRequest } from "../config/axiosConfig";
import { CreateTransactionRequest, CreateTransactionResponse, PaymentRetryRequest, PaymentRetryResponse, ValidateTransactionRequest, ValidateTransactionResponse } from "../interfaces/payment.interface";

class PaymentService {
    baseUrl: string;
    token: string;
    nonce: string;

    constructor(token: string, nonce: string) {
        this.baseUrl = "payments";
        this.token = token;
        this.nonce = nonce;
    }

    private get headers() {
        return {
            "Content-Type": "application/json",
            Token: this.token,
            Nonce: this.nonce,
        };
    }

    async createTransaction(
        body: CreateTransactionRequest
    ): Promise<{ status: number; data: CreateTransactionResponse }> {
        const { status, data } = await postRequest(`${this.baseUrl}/createTransaction/`, body, this.headers);
        return {
            status: status,
            data: data,
        };
    }
    async validateTransactionStatus(
        body: ValidateTransactionRequest
    ): Promise<{ status: number; data: ValidateTransactionResponse }> {
        const { status, data } = await postRequest(`${this.baseUrl}/validateTransactionStatus/`, body, this.headers);
        return {
            status: status,
            data: data,
        };
    }
    async paymentRetry(
        body: PaymentRetryRequest
    ): Promise<{ status: number; data: PaymentRetryResponse }> {
        const { status, data } = await postRequest(`${this.baseUrl}/paymentRetry/`, body, this.headers);
        return {
            status: status,
            data: data,
        };
    }
    
}

export default PaymentService;
